import React from 'react';

import { Typography } from '@mui/material';

const PageHeader: React.FunctionComponent = ({ children }) => {
  return (
    <Typography
      variant='h3'
      color='primary'
      sx={{ my: 3, textAlign: 'center' }}
    >
      {children}
    </Typography>
  );
};

export default PageHeader;
